import { useState } from "react";
import { updateAutoRepost } from "./action";
import { useDispatch, useSelector } from "react-redux";
import { jobOpportunitySelector } from "./selector";

export default (props) => {
  const { isAutoPostAllowed } = useSelector(jobOpportunitySelector);
  const dispatch = useDispatch();

  const handleCheckboxChange = (event) => {
    dispatch(updateAutoRepost(event.target.checked));
  };

  return (
    <div className="card h-100">
      <div className="card-header">
            <h3 class="card-title">Auto Repost</h3>
          </div>
          <div className="card-body d-flex align-items-center">
          <di style={{padding:"0.5rem"}} className="col border rounded-3  ">
                <label className="d-flex align-items-center h-100 my-auto">
                  <input
                    type="checkbox"
                    checked={isAutoPostAllowed}
                    onChange={handleCheckboxChange}
                  />
                  Auto Repost
                </label>
              </di>
      </div>
    </div>
  );
};
